(function () {
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll('[data-weight-reveal]:not([data-weight-reveal-bound])');
  if (!targets.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  targets.forEach(function (el) {
    el.setAttribute('data-weight-reveal-bound', 'true');
    io.observe(el);
  });
})();
